var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-statistic"},[_c('bar-chart',{attrs:{"styles":_vm.myStyles,"chart-data":_vm.chartData,"options":_vm.options}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }